import RadioGroup from "ui/crfs/radio_group";

import Year from "ui/crfs/year";
import Select from "ui/crfs/select";
import Time from "ui/crfs/time";
import Date from "ui/crfs/date";
import DropDown from "ui/crfs/drop_down";
import Text from "ui/crfs/text";
import Int from "ui/crfs/int";
import Decimal from "ui/crfs/decimal";
import BloodPressure from "ui/crfs/blood_pressure";
import DateTime from "ui/crfs/date_time";
import Heading from "ui/crfs/heading";
import Weight from "ui/crfs/weight";
import BloodPressureDateTime from "ui/crfs/blood_pressure_date_time";
import BloodTestResult from "ui/crfs/blood_test_result";
import AddAnother from "ui/crfs/add_another";
import { arrayHaveCommonItems } from "util/helpers";

export const resolveCrfDataFlag = (field_array, crf_data) => {
  field_array = field_array.filter((f) => !["heading", "add_another"].includes(f.type));
  let arr = field_array.map((field) => {
    if (field.value_obj?.missing) {
      return true;
    } else {
      return renderFieldComponent(field, field_array, {
        return_data_state_only: true,
        updateFieldFlag: () => () => {},
        crf_data,
      });
    }
  });
  let arr_required = field_array
    .filter((field) => field.required)
    .map((field) => {
      if (field.value_obj?.missing) {
        return true;
      } else {
        return renderFieldComponent(field, field_array, {
          return_data_state_only: true,
          updateFieldFlag: () => () => {},
          crf_data,
        });
      }
    });
  if (arr_required.length && !arr_required.includes(false)) {
    return "all_data";
  } else if (!arr_required.length && !arr.includes(false)) {
    return "all_data";
  } else if (arr.includes(true)) {
    return "data";
  } else {
    return null;
  }
};

export const shouldRenderDataField = (field, field_array, crf_data, user_domains) => {
  //check for subject randomization status against domains
  if (field.domains?.length && !arrayHaveCommonItems(field.domains, crf_data?.randomization_domains || [])) {
    return null;
  }

  //check for user access to domain assignment
  if (field.domains?.length && !arrayHaveCommonItems(field.domains, user_domains)) {
    return null;
  }

  //check that the question is not specifying the subject to be in a specific region
  if (field.regions?.length && !field.regions.includes(crf_data.region_id)) {
    return null;
  }

  const arrayify = (val) => {
    if (val?.constructor === Array) {
      return val;
    } else {
      try {
        val = JSON.parse(val);
        if (val?.constructor === Array) {
          return val;
        } else {
          if (val?.constructor === String) {
            return val?.split(",").map((a) => a.trim()) || [];
          } else {
            return [val];
          }
        }
      } catch (err) {
        if (val?.constructor === String) {
          return val?.split(",").map((a) => a.trim()) || [];
        } else if ([undefined, null].includes(val)) {
          return [];
        } else {
          return [val];
        }
      }
    }
  };

  const process_field_rule = (rule, field_array) => {
    let compared_field = field_array.find((f) => f.id === parseInt(rule.field_id));
    if (rule.logic_type === "equals" && rule.value) {
      return compared_field.value_obj?.value === rule.value;
    } else if (rule.logic_type === "not_equals" && rule.value) {
      return compared_field.value_obj?.value !== rule.value;
    } else if (rule.logic_type === "contains" && rule.value) {
      let val1 = arrayify(compared_field.value_obj?.value);
      let val2 = arrayify(rule.value);
      return arrayHaveCommonItems(val1, val2);
    } else if (rule.logic_type === "not_contains" && rule.value) {
      let val1 = arrayify(compared_field.value_obj?.value);
      let val2 = arrayify(rule.value);
      return !arrayHaveCommonItems(val1, val2);
    } else if (rule.logic_type === "has_data") {
      let val1 = arrayify(compared_field.value_obj?.value);
      return !!val1.length;
    } else if (rule.logic_type === "no_data") {
      let val1 = arrayify(compared_field.value_obj?.value);
      return !val1.length;
    } else if (rule.logic_type === "multiple_or") {
      if (rule.rules?.length) {
        let _rules = rule.rules.map((rule) => {
          compared_field = field_array.find((f) => f.id === parseInt(rule.field_id));
          return process_field_rule(rule, field_array);
        });
        return _rules.includes(true);
      } else {
        return false;
      }
    }
  };

  if (field.display_logic) {
    if (field.display_logic?.rules?.length) {
      let rules = field.display_logic.rules;
      rules = rules
        .filter((rule) => rule.field_id || rule.logic_type === "multiple_or")
        .map((rule) => {
          return process_field_rule(rule, field_array);
        });
      if (rules.includes(false)) {
        return false;
      } else {
        return true;
      }
    }

    // all the following for backward compatibility before rules were an array
    if (
      !field.display_logic?.rules &&
      field.display_logic?.field_id &&
      (!field.display_logic.logic_type || field.display_logic.logic_type === "equals")
    ) {
      let compared_field = field_array.find((f) => f.id === parseInt(field.display_logic.field_id));
      if (field.display_logic.value) {
        if (compared_field.value_obj.value !== field.display_logic.value) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  } else {
    return true;
  }
};

export const renderFieldComponent = (
  field,
  field_array,
  {
    subject_id,
    crf_id,
    setQuery,
    crf_data,
    updateCrfQueryStatus,
    form_type,
    multi_entry_crf_id,
    crfStatus,
    user_domains,
    updateFieldValue,
    updateFieldFlag,
    linked_crf_id,
    visit_index,
    toggleHistory,
    selected_field_id,
    return_data_state_only = false,
    return_data_ids_only = false,
    setQueryModalData,
    crfFlags = [],
    showHistory = false,
  }
) => {
  const get_active_version_string = (versioning_field_id) => {
    return (
      field_array.find((f) => parseInt(f.id) === parseInt(versioning_field_id)).value_obj.value ||
      field_array.find((f) => parseInt(f.id) === parseInt(versioning_field_id)).options[0].value
    );
  };
  const base_props = {
    field,
    // key: field.id,
    subject_id: subject_id,
    crf_id: crf_id,
    field_id: field.id,
    options: field.versioning_field
      ? field.options && field.options[get_active_version_string(field.versioning_field_id)]
      : field.options,
    title: field.versioning_field ? field.label[get_active_version_string(field.versioning_field_id)] : field.label,
    uval: field.uval,
    query: field.query,
    setQuery: setQuery,
    calcUpdateToCrfStatus: updateCrfQueryStatus,
    enableQuery: true,
    form_type,
    multi_entry_crf_id,
    crf_name: (crf_data && crf_data.name && crf_data.name.toUpperCase()) || "",
    crfStatus,
    read_only: !crf_data?.write_permission,
    // read_only: !crf_data?.write_permission || crfFlags?.includes("site_signoff"),
    // read_only:
    //   !crf_data?.write_permission || crf_data?.qc_status.includes("monitored") || crfStatus === "data_complete",
    crf_slug: crf_data?.slug,
    visit_index,
    toggleHistory,
    selected_audit_icon: selected_field_id === field.id,
    first_randomized_on: crf_data?.first_randomized_on,
    setQueryModalData,
    _updateFieldFlag: updateFieldFlag(
      field.value_obj?.data_id,
      field.id,
      crf_id,
      multi_entry_crf_id || null,
      linked_crf_id || null
    ),
    showHistory,
  };

  if (!shouldRenderDataField(field, field_array, crf_data, user_domains)) {
    return null;
  }
  if (return_data_state_only && field?.value_obj?.missing) {
    return true;
  }
  if (return_data_ids_only && field?.value_obj?.missing) {
    return field.value_obj.data_id;
  }
  let ret_element = null;
  let is_data_filled = null;

  if (field.type === "year") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Year
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "year",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "text") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Text
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "text",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
          placeHolder={field.placeHolder}
        />
      );
    }
  } else if (field.type === "radio") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <RadioGroup
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "radio",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
          orientation={field.orientation || ""}
        />
      );
    }
  } else if (field.type === "select") {
    try {
      is_data_filled = !!JSON.parse(field.value_obj?.value).length;
    } catch (err) {
      is_data_filled = false;
    }
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Select
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "select",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "drop_down") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <DropDown
          key={field.id}
          {...base_props}
          uval={field.value_obj?.value || ""}
          onUpdate={(value) => {
            updateFieldValue(
              field.id,
              "drop_down",
              crf_id,
              multi_entry_crf_id,
              linked_crf_id || null,
              field.label || ""
            )({ value });
          }}
          orientation={field.orientation || ""}
          options={field.options.filter((option) =>
            option.regions?.length ? option.regions.includes(crf_data.region_id) : true
          )}
        />
      );
    }
  } else if (field.type === "time") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Time
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "time",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "date") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Date
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "date",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "datetime") {
    is_data_filled = !!(field.value_obj?.value && field.value_obj?.value2);
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <DateTime
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "datetime",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "dropdown") {
    ret_element = (
      <DropDown
        key={field.id}
        {...base_props}
        onUpdate={updateFieldValue(
          field.id,
          "dropdown",
          crf_id,
          multi_entry_crf_id,
          linked_crf_id || null,
          field.label || ""
        )}
      />
    );
  } else if (field.type === "int") {
    is_data_filled = !!field.value_obj?.value || field.value_obj?.value === 0;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Int
          key={field.id}
          {...base_props}
          length={field.max_length || 2}
          onUpdate={updateFieldValue(
            field.id,
            "int",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
          placeholder={field.placeHolder}
        />
      );
    }
  } else if (field.type === "weight") {
    is_data_filled = !!(field.value_obj?.value && field.value_obj?.value2);
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Weight
          key={field.id}
          {...base_props}
          length={field.max_length || 2}
          onUpdate={updateFieldValue(
            field.id,
            "weight",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
          placeholder={field.placeHolder}
        />
      );
    }
  } else if (field.type === "decimal") {
    is_data_filled = !!field.value_obj?.value;
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <Decimal
          key={field.id}
          {...base_props}
          whole_length={field.whole_length}
          decimal_length={field.decimal_length}
          units={field.units}
          onUpdate={updateFieldValue(
            field.id,
            "decimal",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "blood_pressure") {
    is_data_filled = !!(field.value_obj?.value && field.value_obj?.value2);
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <BloodPressure
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "blood_pressure",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "heading") {
    if (return_data_state_only) {
      ret_element = true;
    } else if (return_data_ids_only) {
      return null;
    } else {
      ret_element = (
        <Heading
          key={field.id}
          {...base_props}
          position={field.position}
          color={field.color}
          onUpdate={updateFieldValue(
            field.id,
            "blood_pressure",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "blood_pressure_date_time") {
    is_data_filled =
      !!(field.value_obj?.value && field.value_obj?.value2 && field.value_obj?.value3 && field.value_obj?.value4) ||
      field.value_obj?.value5 === "not_done";
    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <BloodPressureDateTime
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "blood_pressure_date_time",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "blood_test_result") {
    if (field.value_obj?.value?.toLowerCase() === "no") {
      is_data_filled = true;
    } else if (field.value_obj?.value?.toLowerCase() === "") {
      is_data_filled = false;
    } else {
      is_data_filled = !!(
        ((field.options?.int_value && field.value_obj?.value2) || !field.options?.int_value) &&
        ((field.options?.decimal_value && field.value_obj?.value3) || !field.options?.decimal_value) &&
        ((field.options?.units_value && field.value_obj?.value4) || !field.options?.units_value)
      );
    }

    if (return_data_state_only) {
      ret_element = is_data_filled;
    } else if (return_data_ids_only) {
      ret_element = (is_data_filled && field.value_obj.data_id) || null;
    } else {
      ret_element = (
        <BloodTestResult
          key={field.id}
          {...base_props}
          onUpdate={updateFieldValue(
            field.id,
            "blood_test_result",
            crf_id,
            multi_entry_crf_id,
            linked_crf_id || null,
            field.label || ""
          )}
        />
      );
    }
  } else if (field.type === "add_another") {
    if (return_data_ids_only) {
      return null;
    }
    ret_element = <AddAnother key={field.id} {...base_props} field_array={field_array} />;
  }
  return ret_element;
};
